import { Navigate } from "react-router-dom";
import { useSupabaseAuth } from "contexts/SupabaseAuthContext";
import { CircularProgress, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { supabase } from "services/supabase";

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useSupabaseAuth();
  const [isAdmin, setIsAdmin] = useState(null);
  const [checkingRole, setCheckingRole] = useState(true);

  useEffect(() => {
    const checkAdminRole = async () => {
      if (!currentUser) {
        setIsAdmin(false);
        setCheckingRole(false);
        return;
      }

      try {
        const { data: adminRole, error } = await supabase
          .from("user_roles")
          .select("role")
          .eq("uid", currentUser.id)
          .eq("role", "admin")
          .maybeSingle();

        if (error) {
          console.error("Error checking admin role:", error);
          setIsAdmin(false);
        } else {
          setIsAdmin(!!adminRole);
        }
      } catch (error) {
        console.error("Error checking admin role:", error);
        setIsAdmin(false);
      } finally {
        setCheckingRole(false);
      }
    };

    if (!loading) {
      checkAdminRole();
    }
  }, [currentUser, loading]);

  if (loading || checkingRole) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!currentUser || !isAdmin) {
    // Sign out if user doesn't have admin role
    if (currentUser && !isAdmin) {
      supabase.auth.signOut();
    }
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
